import { Loader } from "apps/visits/packages/ui/src/components/loader";
import { matchPath } from "react-router-dom";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { useGetOrder } from "../../api/get-order";
import { ThankYou } from "../../components/thank-you";
import { useFinalOrderEvent } from "../../hooks/use-final-order-event";
import type { Order } from "../../models/order";
import { getConfig } from "../../models/voucher-distribution";
import { useVouchersDistributionState } from "../../store/use-vouchers-distribution-state";
import { emitVouchersPurchase } from "../../utils/emit-vouchers-purchase";
import { consumeVdOrderFor } from "../../utils/vd-order-for";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";

const emitFriendsAndFamilyPurchase = (order: Order) => emitVouchersPurchase(order, { orderFor: consumeVdOrderFor() });

export const ThankYouPage = () => {
  const { voucherDistribution } = useVouchersDistributionState();
  const config = getConfig(voucherDistribution, configName);
  const fullPath = config ? config.path + routes.thankYou.raw() : "";

  const matchPathThankYou = matchPath<{ uuid: Order["uuid"] }>(window.location.pathname, {
    path: fullPath,
    exact: false,
    strict: false,
  });

  const slug = voucherDistribution?.slug || "";

  const { data: orderData, isLoading: isOrderLoading } = useGetOrder({
    slug,
    configName,
    uuid: matchPathThankYou?.params.uuid || "",
    config: {
      enabled: !!matchPathThankYou?.params.uuid && !!voucherDistribution,
    },
  });

  useFinalOrderEvent({
    slug,
    configName,
    order: orderData?.order,
    onPurchase: emitFriendsAndFamilyPurchase,
    errorContext: "friends-and-family thank-you",
  });

  if (!voucherDistribution || isOrderLoading || !orderData)
    return (
      <div className="fixed inset-0 z-50 flex h-screen w-full items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <IntersectionFadeIn className="mx-auto max-w-[1200px] py-10">
      <ThankYou
        vouchers={orderData.order.items}
        voucherDistribution={voucherDistribution}
        configName={configName}
        totalGrossPrice={orderData.order.totalGrossPrice}
        showCurrentConfig
      />
    </IntersectionFadeIn>
  );
};
